export default __webpack_public_path__ + "static/media/rewpeople.86f4e3d4.jpg";